import type { FC } from 'react';

import { IDADE_MINIMA, useCadastro } from '../../../../logica/auth/useCadastro';
import { useEntrarComProvedor } from '../../../../logica/auth/useEntrarComProvedor';
import { CodigoDoEmailLigado } from '../CodigoDoEmailLigado';
import { Cadastro } from './Cadastro';

// /signup — liga a lógica à tela. O código já foi enviado no cadastro: o passo não reenvia ao abrir.
const CadastroLigado: FC = () => {
  const c = useCadastro();
  const provedores = useEntrarComProvedor();
  return (
    <Cadastro
      {...c}
      idadeMinima={IDADE_MINIMA}
      provedores={provedores}
      codigo={<CodigoDoEmailLigado email={c.email.trim()} aoConfirmar={c.aoConfirmar} />}
    />
  );
};

export default CadastroLigado;
